<template>
    <th
        :style="containerStyle"
        :class="containerClass"
        role="columnheader"
        :data-p-frozen-column="frozen"
    >
        <div>{{ column.label }}<span v-if="column.required" class="requiredHeader"></span></div>
    </th>
</template>

<script>
import DomHandler from '../../../common/DOMUtils.js';

export default {
    name: 'EditableHeaderCell',
    props: {
        column: {
            type: Object,
            required: true,
            validator: value => {
                return typeof value.label === 'string';
            }
        },
        columnKey: {
            type: String,
            default: null
        },
        headerStyle: {
            type: Object,
            default: () => {}
        },
        headerStyleCallback: {
            type: Function,
            default: null
        },
        headerClass: {
            type: String,
            default: ''
        },
        headerClassCallback: {
            type: Function,
            default: null
        }
    },
    computed: {
        containerStyle() {
            let style = this.frozen ? [this.styleObject] : [];

            if (this.headerStyle) {
                style.push(this.headerStyle);
            }

            if (this.headerStyleCallback) {
                const renderStyle = this.headerStyleCallback(this.createEventData());

                if (renderStyle) {
                    if (Array.isArray(renderStyle)) {
                        style = style.concat(renderStyle);
                    } else {
                        style.push(renderStyle);
                    }
                }
            }

            return style;
            //return this.frozen ? this.styleObject : undefined;
        },
        containerClass() {
            let renderClass = '';

            if (this.headerClassCallback) {
                renderClass = this.headerClassCallback(this.createEventData());
            }

            let frozenClass = '';
            if (this.frozen) {
                frozenClass = 'table-frozen-column';
            }

            return [this.headerClass ?? '', renderClass, frozenClass].filter(x => x.length !== 0);
            /*if (this.frozen) {
                return 'table-frozen-column';
            }

            return undefined;*/
        },
        frozen() {
            return (
                Object.prototype.hasOwnProperty.call(this.column, 'frozen') && this.column.frozen
            );
        },
        alignFrozen() {
            return this.column.alignFrozen ?? 'left';
        }
    },
    data() {
        return {
            styleObject: {}
        };
    },
    methods: {
        updateStickyPosition() {
            if (this.frozen) {
                let align = this.alignFrozen;

                if (align === 'right') {
                    let right = 0;
                    let next = DomHandler.getNextElementSibling(
                        this.$el,
                        '[data-p-frozen-column="true"]'
                    );

                    if (next) {
                        right = DomHandler.getOuterWidth(next) + parseFloat(next.style.right || 0);
                    }

                    this.$set(this.styleObject, 'insetInlineEnd', right + 'px');
                } else {
                    let left = 0;
                    let prev = DomHandler.getPreviousElementSibling(
                        this.$el,
                        '[data-p-frozen-column="true"]'
                    );

                    if (prev) {
                        left = DomHandler.getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                    }

                    this.$set(this.styleObject, 'insetInlineStart', left + 'px');
                }
            }
        },
        createEventData() {
            const event = {
                columnKey: this.columnKey,
                column: this.column
            };

            return event;
        }
    },

    mounted() {
        if (this.frozen) {
            this.updateStickyPosition();
        }
    },

    updated() {
        if (this.frozen) {
            this.updateStickyPosition();
        }
    }
};
</script>
